function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["id", "className", "customComponents", "isAsync", "isMenuVisibleOnFocus", "isCreatable", "isMulti", "informationCell", "linkCell", "options", "placeholder", "hasError", "noInteractionBorder"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
/* eslint-disable react/jsx-props-no-spreading */
import SelectLib from "react-select";
import AsyncCreatable from "react-select/async-creatable";
import Async from "react-select/async";
import SelectCreatable from "react-select/creatable";
import classNamesMaker from "classnames";
import { MultiValueRemove, ClearIndicator, DropdownIndicator, Menu, MenuList, Option } from "#library/components/SelectFilter/customComponents";
import styles from "#library/components/SelectFilter/select.module.css";
export var Select = function Select(_ref) {
  var id = _ref.id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$customComponents = _ref.customComponents,
    customComponents = _ref$customComponents === void 0 ? null : _ref$customComponents,
    _ref$isAsync = _ref.isAsync,
    isAsync = _ref$isAsync === void 0 ? false : _ref$isAsync,
    _ref$isMenuVisibleOnF = _ref.isMenuVisibleOnFocus,
    isMenuVisibleOnFocus = _ref$isMenuVisibleOnF === void 0 ? false : _ref$isMenuVisibleOnF,
    _ref$isCreatable = _ref.isCreatable,
    isCreatable = _ref$isCreatable === void 0 ? false : _ref$isCreatable,
    _ref$isMulti = _ref.isMulti,
    isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
    _ref$informationCell = _ref.informationCell,
    informationCell = _ref$informationCell === void 0 ? null : _ref$informationCell,
    _ref$linkCell = _ref.linkCell,
    linkCell = _ref$linkCell === void 0 ? null : _ref$linkCell,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "" : _ref$placeholder,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    _ref$noInteractionBor = _ref.noInteractionBorder,
    noInteractionBorder = _ref$noInteractionBor === void 0 ? false : _ref$noInteractionBor,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var customClassNames = classNamesMaker(styles["jds-Select"], _defineProperty({}, styles["jds-Select--hasError"], hasError), _defineProperty({}, styles["jds-Select--noInteractionBorder"], noInteractionBorder), className);
  var customStyles = {
    menuPortal: function menuPortal(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        zIndex: 9999
      });
    }
  };
  var components = _objectSpread({
    IndicatorSeparator: function IndicatorSeparator() {
      return null;
    },
    MultiValueRemove: MultiValueRemove,
    ClearIndicator: ClearIndicator,
    DropdownIndicator: DropdownIndicator,
    MenuList: MenuList,
    Option: Option
  }, customComponents);
  if (!isMenuVisibleOnFocus && isAsync) {
    components.Menu = Menu;
  }
  var defaultAttributes = _objectSpread({
    inputId: id,
    className: customClassNames,
    classNamePrefix: "jds-Select",
    components: components,
    isClearable: true,
    isMulti: isMulti,
    options: options,
    placeholder: placeholder,
    styles: customStyles,
    informationCell: informationCell,
    linkCell: linkCell,
    captureMenuScroll: false,
    blurInputOnSelect: false,
    closeMenuOnSelect: !isMulti
  }, restProps);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isAsync && isCreatable && /*#__PURE__*/React.createElement(AsyncCreatable, defaultAttributes), isAsync && !isCreatable && /*#__PURE__*/React.createElement(Async, defaultAttributes), !isAsync && isCreatable && /*#__PURE__*/React.createElement(SelectCreatable, defaultAttributes), !isAsync && !isCreatable && /*#__PURE__*/React.createElement(SelectLib, defaultAttributes));
};